import home from '@/views/silkRoadBase/components/Home.vue' //首页引入
import TheHome from '../../views/TheHome/theHome'

import information from '@/views/silkRoadBase/components/Information.vue' //资讯引入
import articles from '@/views/silkRoadBase/components/ArticleDetails/Article.vue' //文章详情

import inquiry from '@/views/silkRoadBase/components/Inquiry.vue' //智讯引入
import video_signal from '@/views/silkRoadBase/components/Video_signal.vue' //视讯引入
import videoparticulars from '@/views/silkRoadBase/components/ArticleDetails/videoArticle.vue' //视频详情引入

import report_issue from '@/views/silkRoadBase/components/Custom_reports.vue' //报告期刊列表
// import subject_reports from '@/views/silkRoadBase/components/Subject_reports.vue'; //专题报告引入

import countryreport from '@/views/silkRoadBase/components/CountryReport.vue' //国家报告引入
import riskreports from '@/views/silkRoadBase/components/RiskReports.vue' //风险报告引入

import report from '@/views/silkRoadBase/components/Intelligence.vue' //情报引入
import countryreport_list from '@/views/silkRoadBase/components/countryreportList.vue' //情报引入

import cases from '@/views/silkRoadBase/components/Case.vue' //案例引入
import consult_particulars_organization from '@/views/silkRoadBase/components/Consult_particulars_organization.vue' //咨询首页

import consultorganization from '@/views/silkRoadBase/components/ConsultOrganization.vue'
import consultdetails from '@/views/silkRoadBase/components/ConsultDetails.vue'

import project from '@/views/silkRoadBase/components/Project.vue'				//项目页面引入
import credit from '@/views/silkRoadBase/components/credit.vue'				//信用页面引入
import credits from '@/views/silkRoadBase/components/credits.vue'				//新版信用页面引入
import datapage from '@/views/silkRoadBase/components/datapage.vue'			//数据页面引入
import paper from '@/views/silkRoadBase/components/Paper.vue'			//数据页面引入

import garden from '@/views/silkRoadBase/components/Garden.vue' //园区引入
import intellectual from '@/views/silkRoadBase/components/intellectual.vue' //园区引入
import feedback from '@/views/silkRoadBase/components/Feedback.vue' //需求反馈引入
import allDeal from '@/views/silkRoadBase/components/allDeal.vue' //订单引入
// import dealDetail from '@/views/silkRoadBase/components/dealDetail.vue'; //订单详情引入
import accountSettings from '@/views/silkRoadBase/components/AccountSettings.vue' //个人中心首页引入
import accounts from '@/views/silkRoadBase/components/Account.vue' //个人中心引入
import my_report from '@/views/silkRoadBase/components/My_report.vue' //我的报告引入
import collection from '@/views/silkRoadBase/components/Collection.vue' //收藏管理引入
import contribute from '@/views/silkRoadBase/components/Contribute.vue' //投稿引入
import contributeAdd from '@/views/silkRoadBase/components/contributeAdd.vue' //投稿引入
import contributeEdit from '@/views/silkRoadBase/components/contributeEdit.vue' //投稿引入
import menberCenter from '@/views/silkRoadBase/components/menberCenter.vue' //会员中心引入
import myAttention from '@/views/silkRoadBase/components/myAttention.vue' //我的关注引入
import myComment from '@/views/silkRoadBase/components/myComment.vue' //我的评论引入
import myCommentDetail from '@/views/silkRoadBase/components/myCommentDetail.vue' //我的评论引入
import searchresult from '@/views/silkRoadBase/components/SearchResult.vue'
import theHome from '@/views/TheHome/theHome'
import chinaTopics from '@/views/topics/chinaTopics/chinaTopics'
// import theHome from '../../views/TheHome/theHome' //搜索结果列表

const routes = [
  {
    path: '/',
    redirect: '/home'
  }, //首页默认显示
  {
    path: '/home-pd',
    component: home
  }, //首页
  {
    path: '/home',
    component: theHome,
    meta: {
      keepAlive: true
    }
  }, //首页
  {
    name: 'searchresult',
    path: '/searchresult/:keyword',
    component: searchresult,
    children: [{
      name: 'searchresultId',
      path: 'article/:contentid',
      component: articles
    }]
  }, //搜索结果

  {
    name: 'information',
    path: '/information/:id',
    component: information,
    children: [{
      name: 'articleId',
      path: 'article/:contentid',
      component: articles
    }]
  }, //资讯
  {
    name: 'inquiry',
    path: '/inquiry/:id',
    component: inquiry,
    children: [{
      name: 'inquiryId',
      path: 'article/:contentid',
      component: articles
    }]
  }, //智讯
  {
    name: 'video',
    path: '/video/:id',
    component: video_signal,
    children: [{
      name: 'videoId',
      path: 'article/:contentid',
      component: videoparticulars
    }]
  }, //视讯
  {
    name: 'riskreport',
    path: '/riskreport/:id/:countryname',
    component: riskreports
  }, // 投资报告

  {
    name: 'countryreport',
    path: '/countryreport/:id/:year',
    component: countryreport
  }, //国家报告引入
  {
    name: 'countryreport_list',
    path: '/countryreport/:id/:year/:issueid',
    component: countryreport_list
  }, // 国家报告列表页
  {
    name: 'report',
    path: '/report/:id',
    component: report
  }, //情报
  {
    name: 'report_issue_list',
    path: '/report/:id/issue/:issueid',
    component: report_issue
  }, //期刊列表accounts
  {
    name: 'case',
    path: '/case/:id',
    component: cases,
    children: [{
      name: 'caseId',
      path: 'article/:contentid',
      component: articles
    }]
  }, //案例
  {
    name: 'consult_particulars_organization',
    path: '/consult_particulars_organization/:id/:type',
    component: consult_particulars_organization
  }, //咨询首页
  {
    name: 'consultorganization',
    path: '/consultorganization/:contentid',
    component: consultorganization
  },
  {
    name: 'consultdetails',
    path: '/consultdetails/:name/:contentid',
    component: consultdetails
  },
  {
    name: 'credits',
    path: '/credits',
    component: credits
    /*children: [{
        name: 'articleId',
        path: 'article/:contentid',
        component: articles
    }]*/
  },//新版信用页面
  {
    name: 'credit',
    path: '/credit',
    component: credit
  },//信用页面
  {
    name: 'datapage',
    path: '/datapage',
    component: datapage
  },//数据页面
  {
    name: 'project',
    path: '/project',
    component: project
  },//项目页面
  {
    name: 'paper',
    path: '/paper',
    component: paper
  },//项目页面
  {
    name: 'garden',
    path: '/garden',
    component: garden,
    children: [{
      name: 'gardenId',
      path: 'article/:contentid',
      component: articles
    }]
  }, //园区
  {
    name: 'intellectual',
    path: '/intellectual',
    component: intellectual,
    children: [{
      name: 'intellectualId',
      path: 'article/:contentid',
      component: articles
    }]
  }, //园区
  {
    path: '/feedback',
    component: feedback
  }, //需求反馈

  {
    path: '/accountSettings',
    component: accountSettings,
    children: [{
      path: '/',
      redirect: 'accounts'
    }, //个人中心默认显示
      {
        path: 'accounts',
        component: accounts
      }, //个人中心
      {
        path: 'allDeal',
        component: allDeal
      }, //全部订单
      {
        path: 'collection',
        component: collection
        // children: [{
        //     name: 'collectionArticle',
        //     path: 'article/:contentid',
        //     component: articles
        // }]
      }, //收藏管理
      {
        path: 'menberCenter',
        component: menberCenter
      }, //会员中心
      {
        path: 'myAttention',
        component: myAttention
      }, //我的关注
      {
        path: 'myComment',
        component: myComment
      }, //我的评论
      {
        path: 'myComment/myCommentDetail', //评论详情
        component: myCommentDetail,
        meta: {
          keepAlive: true, //此组件需要被缓存
          isBack: false //用于判断上一个页面是哪个
        }
      },
      {
        path: 'my_report',
        component: my_report
      }, //我的报告
      {
        name: 'contribute',
        path: 'contribute',
        component: contribute
      }, //投稿
      {
        path: 'contribute/contributeAdd/:id?', //新增发布
        component: contributeAdd,
        meta: {
          keepAlive: true, //此组件需要被缓存
          isBack: false //用于判断上一个页面是哪个
        }
      }, {
        path: 'contribute/contributeEdit/:id', //详情
        component: contributeEdit,
        meta: {
          keepAlive: true, //此组件需要被缓存
          isBack: false //用于判断上一个页面是哪个
        }
      }
    ]
  }, //个人中心
  { // 中国省份专题
    path: '/china-topics/:country?',
    name: 'chinaTopics',
    component: chinaTopics,
    meta: {
      keepAlive: true
    }
  }
]

export default routes
